import type { AttestationNotRequiredMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { AttestationNotRequiredDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * Maps the tRPC mutation response to the GraphQL mutation response shape so
 * consumers branching on the result do not need to know which path executed.
 */
const mapTrpcResponseToGraphQL = (data: {
  affected_rows: number;
}): AttestationNotRequiredMutation => ({
  attestationNotRequired: {
    __typename: 'GenericMutationOutput',
    affected_rows: data.affected_rows,
  },
});

// RSP-6891
export const useMarkAttestationsNotRequired = createMutationHook({
  name: 'markNotRequired',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.attestation.notRequired.mutationOptions({ onSuccess }),
  mapInput: (input: { Ids: string[] }) => ({ Ids: input.Ids }),
  mapResponse: (result: { affected_rows: number }) =>
    mapTrpcResponseToGraphQL(result),
  // Parity with the Apollo path: the register feeds the page the action is
  // triggered from, and the per-document status drives the attestation
  // widgets. Both go stale once records are deactivated.
  invalidate: (trpc) => [
    trpc.frontend.attestation.register.queryKey(),
    trpc.frontend.attestation.status.queryKey(),
    // COI-889: the policy version's Attestations tab reads this family.
    trpc.frontend.attestation.recordsForDocument.queryKey(),
    // COI-889: the my-items ribbon counts this entity.
    trpc.frontend.myItems.pathKey(),
  ],
  graphqlDocument: AttestationNotRequiredDocument,
  graphqlVariables: (input: { Ids: string[] }) => ({ Ids: input.Ids }),
});
